import { SvgAttribute } from "@/shared/constants/constants";

export const COMPONENT_NAME = "application-crypto";

export const SVG: SvgAttribute = {
  chevron: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.962" fill-rule="evenodd" clip-rule="evenodd" d="M16.5236 19.8047C16.5513 19.5419 16.5123 19.2919 16.4064 19.0547C14.062 16.7181 11.7261 14.3744 9.39858 12.0234C11.7261 9.67251 14.062 7.32876 16.4064 4.99218C16.5626 4.67967 16.5626 4.3672 16.4064 4.05468C16.0808 3.74676 15.7137 3.69206 15.3048 3.89062C12.7501 6.44531 10.1955 8.99999 7.64077 11.5547C7.48453 11.8672 7.48453 12.1797 7.64077 12.4922C10.1955 15.0469 12.7501 17.6016 15.3048 20.1562C15.8264 20.4057 16.2326 20.2886 16.5236 19.8047Z" fill="#9E9FA8"/>
  </svg>`,
};
